import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, RadioGroup, Link, StepLabel,
  Paper,Autocomplete, Radio, Checkbox, Box, ListSubheader,List,
  Button, MenuItem, InputLabel,Select, FormControl, FormHelperText, FormGroup, FormControlLabel, ListItem,
} from '@mui/material';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import {  
  createApplication,
  fetchApplication,
  
  selectApplicationById,
  rescheduleApplicationOnce,
  rescheduleApplicationWholeSeries,


} from '../store/applicationSlice' 

import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllFloors,
  selectFloorById,
}  from '../store/floorSlice'




import {useAppAuthContext} from '../utils/AppAuthContext'


import { DesktopDatePicker , DatePicker} from '@mui/x-date-pickers';
import { DateTimePicker  as DesktopDateTimePicker } from '@mui/x-date-pickers'
//import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { format, set } from 'date-fns';

import ReoccurenceDialog from './ReoccurenceDialog'

import ClockIcon from '@mui/icons-material/Schedule';


import {usePlayContext} from '../utils/PlayContext';

import {  useNavigate, useParams } from 'react-router-dom';
import { BorderInner } from '@mui/icons-material';

import {getTimeStr, getDateISOString, 
  getDateTime, getValidEndTimes, allStartTimes, allEndTimes,
   getAllDays, getWeekDayName} from '../utils/timeConfig'



const ApplyReScheduleePage = () => {

  const {id}=useParams()
  const myInvitation  = useSelector(selectApplicationById(id))

  const navigate = useNavigate()
  
  const {
      op, setOp,
       setStatus,  setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
       openSnackToast
    }=usePlayContext()

    const {vmsConfig} = useAppAuthContext()

    
  const dispatch = useDispatch()

  
  const oring_date1 = Boolean(myInvitation?.formattedStartTm) ?  
        format (new Date(myInvitation.formattedStartTm), 'yyyy-MM-dd'):''
  const oring_time1  = Boolean(myInvitation?.formattedStartTm) ?  
        format (new Date(myInvitation.formattedStartTm), 'HH:mm'):''

  const oring_date2 = Boolean(myInvitation?.formattedEndTm) ?  
        format (new Date(myInvitation.formattedEndTm), 'yyyy-MM-dd'):''
  const oring_time2 = Boolean(myInvitation?.formattedEndTm) ?  
        format (new Date(myInvitation.formattedEndTm), 'HH:mm'):''


  
  
  const floors = useSelector(selectAllFloors)
  

  const [timeMode, setTimeMode] = useState('normal')

  const [startDate, setStartDate] = useState(Boolean(myInvitation?.formattedStartTm) ?  new Date(myInvitation.formattedStartTm):null)
  const [startDateError, setStartDateError] = useState('')
  
  const [startTime, setStartTime] = 
      useState(Boolean(myInvitation?.formattedStartTm) ? format(new Date(myInvitation.formattedStartTm), 'HH:mm'):null)
  const [startTimeError, setStartTimeError] = useState('')

  const [endDate, setEndDate] = 
    useState( Boolean(myInvitation?.formattedEndTm) ?  new Date(myInvitation.formattedEndTm):null);
  const [endDateError, setEndDateError] = useState('')

  const [endTime, setEndTime] = 
  useState(Boolean(myInvitation?.formattedEndTm) ? format(new Date(myInvitation.formattedEndTm), 'HH:mm'):null)
  const [endTimeError, setEndTimeError] = useState('')


  // const [startDateTime, setStartDateTime] = 
  //   useState( Boolean(myInvitation?.formattedStartTm) ?  new Date(myInvitation.formattedStartTm):null);
  // const [startDateTimeError, setStartDateTimeError] = useState('');
  // const [endDateTime, setEndDateTime] = 
  //     useState( Boolean(myInvitation?.formattedEndTm) ?  new Date(myInvitation.formattedEndTm):null);
  // const [endDateTimeError, setEndDateTimeError] = useState('');


  
  const [reoccurence, setReoccurence] = useState(undefined)
  const [reoccurenceError, setReoccurenceError] = useState('');


  
  
  const [remarks, setRemarks] = useState( Boolean(myInvitation?.remarks) ?  myInvitation.remarks:'');
  const [reasonVisit, setReasonVisit] = useState('');
  
  const [floor, setFloor] = 
      useState( Boolean(myInvitation?.floor) ?  myInvitation.floor:'');
  const [floorError, setFloorError] = useState('');




  const anythingChanged=()=>
  {
    if (timeMode==='normal')
    {
      if (!startDate || !endDate || !startTime || !endTime) return false
      return  oring_date1!==format(startDate, 'yyyy-MM-dd') ||
              oring_date2!==format(endDate, 'yyyy-MM-dd') ||
              oring_time1 !== startTime ||
              oring_time2 !== endTime ||
              myInvitation.floor!==floor && Boolean(floor) ||
              myInvitation.remarks!==remarks && Boolean(remarks)

    }
    else
      return false;

  }

  const doFetchData = async ()=>{
      setStatus('processing')
      try
      {
          let xInvitation = await dispatch(fetchApplication(id)).unwrap();
          console.log("myInvitation fetched::")
          console.log(xInvitation)


          const jr = myInvitation.reoccurenceData? JSON.parse(myInvitation.reoccurenceData):undefined 

          if (jr?.rangeStart)
          {
            jr.rangeStart=new Date(jr.rangeStart)
          }
          if (jr?.rangeUntil)
          {
            jr.rangeUntil=new Date(jr.rangeUntil)
          }


          setReoccurence(jr)
          setStatus('idle')
      }
      catch (ex)
      {
        setStatus('error')
        setErrorMessage("Can not retrieveie Invitation info")
      } 
  }


  //const maxStartDay = new Date(Date.now()+3600*24*1000 *vmsConfig.maxInvitationAdvanceDays)
  
  // const getMaxEndDateTime=()=>
  // {
  //     let start=startDateTime
  //     if (!Boolean(start) || isNaN(start))
  //     {
  //       start = new Date();
  //     }
  //     return new Date(start.getTime()+3600*24*1000 *vmsConfig.maxInvitationDays)
    
  // }


  
  useEffect(() => 
  {
      setAppTitle( ['Invitations', myInvitation?.reason,  myInvitation.id, 'Reschedule'])
      setErrorMessage('')
      setErrorTitle('')
      setOp('')

      doFetchData();
      return () => {
        setErrorMessage('')
        setErrorTitle('')
        setOp('')
        }

  }, [])


  const onTimeModeChanged = (value)=>
  {
      if ('normal'===value)
      {
        //setReoccurence(undefined) 
        setReoccurenceError('')
      }
      else
      {
          //setStartDateTime(null)
          setStartDateError('')
          setStartTimeError('')
          setEndTimeError('')
          setEndDateError('')
      }
      setTimeMode(value)
  }

   
 
   const onReScheduleClicked = async ()=>
   {
      let errNo=0
    
    
      //let tmp1 = Date.parse(startDateTime);
    
      setErrorMessage('')
      setErrorTitle('')
      setStartDateError('')
      setStartTimeError('')
      setEndDateError('')
      setEndTimeError('')
      
      let body={
        id: myInvitation.id,
        timeMode,
      }

      if (timeMode==='normal')
      {
        let date1 = null;
         let date2 = null;
         let time1 = null;
         let time2 = null;
         const today_date = format(new Date(),'yyyy-MM-dd') 
         const today_time = format(new Date(),'HH:mm') 

      
         if (!Boolean(startDate))
         {
             errNo++;
             setStartDateError("Start Date is required")
         }      
         else if ( !Boolean(date1=getDateISOString(startDate)))
         {
           errNo++;
           setStartDateError("Start Date is invalid") 
         }
         else  if (date1<today_date)
         {
           errNo++
           setStartDateError("Start Date cannot be earlier than current date")
         }


         if (!Boolean(endDate))
         {
             errNo++;
             setEndDateError("End Date is required")
         }      
         else if ( !Boolean(date2=getDateISOString(endDate)))
         {
           errNo++;
           setEndDateError("End Date is invalid") 
         }
         else if (date2<date1 || date2<today_date)
         {
           errNo++
           setEndDateError("End Date cannot be earlier than start date")

         }
         //alert(date2+'--'+today_date)
       
         if (!Boolean(startTime))
         {
           errNo++;
           setStartTimeError("Start time is required")
         }
         else if (!Boolean(time1=getTimeStr(startTime)))
         {
           errNo++;
           setStartTimeError("Start time is invalid")
         }
        

         if (!Boolean(endTime))
         {
           errNo++;
           setEndTimeError("End time is required")
         }
         else if (!Boolean(time2=getTimeStr(endTime)))
         {
           errNo++;
           setEndTimeError("End time is invalid")
         }
       


         if (errNo>0) return

         let tmp1 = Date.parse(getDateTime(startDate, startTime));
         let tmp2 = Date.parse(getDateTime(endDate, endTime));
       
         if (tmp1<Date.now())
         {
           errNo++
           setStartTimeError("Start Time cannot be earlier than current time")
           
         }
         if (tmp2<=tmp1)
         {
           errNo++
           setEndTimeError("End Time cannot be earlier than start time")
           
         }
       if (errNo>0) return

       body.startTm=getDateTime(startDate, startTime)
       body.endTm=getDateTime(endDate, endTime)


      }
      else if (timeMode==='reoccurence')
      {
          setStartDateError('')
          setStartTimeError('')
          setEndDateError('')
          setEndTimeError('')
        
          if (!reoccurence?.days || reoccurence?.days.length===0)
          {
            errNo++
            setReoccurenceError('No reoccurence dates provided')
          }
          else
          {
            setReoccurenceError('')
            //body.reoccurrenceData = JSON.stringify(reoccurence);
            body.reoccurenceMessage = reoccurence.message;
            body.reoccurenceData = JSON.stringify({...reoccurence, days:undefined});
            
            body.days =reoccurence.days
          }
      }


      
      if (!Boolean(floor))
      {
          errNo++
          setFloorError('Floor is required')
      }  
      else 
        setFloorError('')
        
      
      
      if (errNo>0)
      {
          return
      }




      body.floor=floor
      body.remarks = remarks;

      //if (timeMode==='reoccurence') alert('reoccurence')
      
      //alert(JSON.stringify(body))
      
      try
      {
        setStatus('processing')
        
        let result=null;

        if (timeMode==='normal')
        {
          result = await dispatch(rescheduleApplicationOnce(body)).unwrap()
        }
        else if (timeMode==='reoccurence')
        {
          return
          result = await dispatch(rescheduleApplicationWholeSeries(body)).unwrap()
        }
        else
        {
            alert("wrong timeMode::"+timeMode)
        }
        //return
        console.log("done---------------------");
        console.log(result);

        if (result.result===0)
        {
          setStatus('success')
          navigate("/invitations")
          openSnackToast("Invitation has been successfully re-scheduled")
        }
        else
        {
          setStatus('error')
            setErrorMessage(result.message)

        }

      }
      catch (ex){
        setErrorMessage(ex.message)
        setStatus('error')
        console.error("xxx::"+ex.message);

      }
      
  }

  const showReoccurence =()=>{

    
      setOp('reoccurence')


  }
  const completeReoccurence =(data)=>{
    setOp('')
    //alert("completeReoccurence")

    if (data)
    {
      setReoccurence(data)
      setReoccurenceError('')
    }
  }

  //const enanbledClick = myGroup || (listData && listData.length>0)

  return (
    <Box>

      
      <Paper sx={{border:'none', justifyContent: "flex-start", px:2, py: 1, 
            bgcolor:'none'}} elevation={0} >
        
        
          
          {
            Boolean(myInvitation?.reoccurenceId) &&
            <React.Fragment>
            <Box sx={{width:'100%',  display:'none', justifyContent:'center', }}>
                  <FormControl sx={{ bgcolor:'@@red'}}>
                        <RadioGroup
                                size='small'
                                row
                                onChange={event => onTimeModeChanged(event.target.value)}
                                value={timeMode}
                                >
                            <FormControlLabel 
                                size='small'
                                sx={{ mr:{xs:5, sm:8, md:12}}}
                                value="normal" control={<Radio />} label="Reschedule Once" />

                            <FormControlLabel 
                                size='small'
                                value="reoccurence" control={<Radio />} label="Reschedule Whole Series" />
            
                        </RadioGroup>
                    </FormControl>
                
            </Box>
            <hr style={{display:'none'}}/>
            </React.Fragment>
          }
          {timeMode==='normal' &&

          <Grid
            sx={{mt:1}}
            container
            spacing={2}
            direction={'row'}
            alignItems={'center'}
          >

          <Grid container item  xs={12} sm={12}  md={6}   sx={{px:0}} spacing={2}>
              <Grid item xs={1} sm={2}  >
              </Grid>


              <Grid item xs={5}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                                value={startDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setStartDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(startDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ startDateError?startDateError:'DD/MM/YYYY' } 
                                              label="Start Date"
                                              //value={nestartDateTime}
                                              //onChange={(newValue) => {  setStartDateTime(newValue);}
                                            
                                            
                            
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={5}sm={4}  sx={{px:1}}>
                <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_start_timr" 
                      value={startTime}
                options={allStartTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setStartTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setStartTime(e.target.value);}}
                        error={Boolean(startTimeError)}
                        label="Start Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(startTimeError) ? startTimeError : "HH:mm"}
                      />}

                /> 
                  {/*<FormControl required  fullWidth size="small">
                     <InputLabel id="id_start_time_label" size='sm'>Start Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_tart_time_label"
                            error={Boolean(startTimeError)}
                            id="id_tart_time"
                            value={startTime}
                            label={"Start Time"}
                            onChange={(e)=>setStartTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allStartTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(startTimeError) }>
                          {Boolean(startTimeError) ?startTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}
                  
                </Grid>
            </Grid>
            <Grid container item  xs={12} sm={12}  md={6}   sx={{px:0}} spacing={2}>
              <Grid item xs={1} sm={2}  md={1} lg={1}>
              </Grid>

             <Grid item xs={5}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker 
                                value={endDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setEndDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(endDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ endDateError ?  endDateError :'DD/MM/YYYY'}
                                              label="End Date"
                                              //value={nestartDateTime}
                                              //onChange={(newValue) => {  setStartDateTime(newValue);}
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={5} sm={4}  sx={{px:1}}>
                  {/* <FormControl required  fullWidth  size="small">
                    <InputLabel id="id_end_time_label" size='sm'>End Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_end_time_label"
                            error={Boolean(endTimeError)}
                            id="id_end_time"
                            value={endTime}
                            label={"End Time"}
                            onChange={(e)=>setEndTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allEndTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(endTimeError) }>
                          {Boolean(endTimeError) ?endTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}

                    <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_end_timr" 
                      //popupIcon={<ArrowDropDownIcon />}
                value={endTime}
                options={allEndTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setEndTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setEndTime(e.target.value);}}
                        error={Boolean(endTimeError)}
                        label="End Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(endTimeError) ? endTimeError : "HH:mm"}
                      />}

                /> 
                  </Grid>
              </Grid>

          </Grid>
          }
          {timeMode==='reoccurence' &&
            <>
            {
                  op!=='reoccurence' &&
                  <React.Fragment>
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    <Typography variant="subtitle1"><strong>Reoccurence:&nbsp;</strong></Typography>
                    <Link component="button" 
                          variant="subtitle1"
                          onClick={showReoccurence}
                          sx={{bgcolor:'', fontWeight:555}}
                          >{reoccurence?.message?reoccurence?.message:'Not Defined Yet'}</Link>
                  </Box>
                  { 
                      Boolean(reoccurenceError) &&
                  
                  <Box sx={{mt:2, display:'flex', justifyContent:'center'}}>
                    <Typography variant="h6" color='error'><strong>{reoccurenceError}</strong></Typography>
                    
                  </Box>
                  }
                  <Box sx={{display:'flex', mt:1, justifyContent:'center', }}>
                    { reoccurence&& reoccurence.days && reoccurence.days.length>0 && 
                      <>
                      <Accordion disableGutters dense 
                          sx={{width:'100%', p:0, border:0, m:1, bgcolor:'#f4f4ff'}}>
                        <AccordionSummary 
                          sx={{p:0,m:0}}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography sx={{pl:2}}><strong>Scheduled Date Time(s)</strong></Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{p:0, m:0}}>
                        
                    <Grid container spacing={1} alignItems="center">
                        {
                            reoccurence.days.map((d,i)=>
                              (<Grid item key={i}  
                                sx={{m:0}}
                                xs={12} sm={6} md={4} lg={3}
                                  disableGutters>
                                <ListItem variant="subtitle1">
                                  <ClockIcon size='small' sx={{mr:1}}/>{d.text}
                                </ListItem>
                              </Grid>)
                            )


                        }

                    </Grid>
                        </AccordionDetails>
                        </Accordion>
                    
                    </>
                    }
                  </Box>
                  </React.Fragment>

            }
            {
                  op==='reoccurence' &&
                  <>
                 

                  <ReoccurenceDialog
                      open={true}
                      data={reoccurence}
                      callback={completeReoccurence}
                  ></ReoccurenceDialog>

                  </>
              }
            
            </>
          }
      


        <Grid
              sx={{mt:1}}
              container
              spacing={2}
              direction={'row'}
              alignItems={'center'}
            >
       
          <Grid item lg={2}  sx={{display:{xs:'none', lg:'block'}}}>
          </Grid>
           
          <Grid item xs={12} sm={6}  lg={4} >
              <FormControl required  fullWidth >
                <InputLabel id="id_floor_label" >Floor to Visit</InputLabel>
                    <Select
                        required
                        labelId="id_floor_label"
                        error={Boolean(floorError)}
                        id="id_flooe"
                        value={floor}
                        label={"Floor to Visit"}
                        onChange={(e)=>setFloor(e.target.value)}
                        
                        >
                      <MenuItem value={''}></MenuItem>
                      
                      {
                          floors.map( (ct)=>
                            (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                          )
                      }
                      
                  </Select>
                    <FormHelperText error={Boolean(floorError) }>
                      {Boolean(floorError) ? floorError:'Please select floor to visit'}
                    </FormHelperText>
                            
                </FormControl>
          
            </Grid>
            <Grid item xs={12} sm={6}  lg={4}  sx={{/*bgcolor:{lg:'red', xl:'green', md:'yellow'}*/}}>
            <TextField 
                //required
                fullWidth
                value={remarks}
                id="id_remarks" label="Remarks" type="text" 
                onChange = { e=>setRemarks(e.target.value)}
                inputProps={{ maxLength: 40, minLength:5 }}
                helperText={ "Remarks (optional)"}/>
        </Grid>

         </Grid>


          
        <Box sx={{mt:2, px:{xs:1, sm:2, md:2, lg:6},
            display:'flex',  width:'100%', justifyContent: 'space-around'}}>


            <Button variant="outlined" 
              disabled={!anythingChanged()}
              color='success'
              sx={{textTransform:'none'}}
              onClick={onReScheduleClicked}
            > 
              Proceed to Reschedule 
            </Button>
            <Button variant="outlined" 
                sx={{textTransform:'none'}}
                //variant="contained" 
                color='success' 
              //disabled = {status==='success'}
              onClick={e=>navigate(-1)}
            > Cancel</Button>

        </Box>
      
      </Paper>
      

      
    </Box>
  );
};

export default ApplyReScheduleePage;
